<script>
  import { getContext, untrack } from 'svelte';
  import Checkbox from './Checkbox.svelte';

  let { value = null, children = undefined } = $props();

  const { searchValue, onChange, store, register } = getContext('select');
  let visible = $state(true);
  let container = $state(null);

  $effect(() => {
    if (searchValue && container) {
      visible = container.innerText
        .toLowerCase()
        .includes($searchValue.toLowerCase());
    }
  });

  $effect(() => {
    if (container && register) {
      const label = container.textContent;
      untrack(() => register(value, label));
    }
  });

  const checked = $derived($store.includes(value));

  const onClick = () => onChange(value, !$store.includes(value));
</script>

<div class={!visible && 'hidden'}>
  <Checkbox {value} onchange={onClick} {checked}>
    <div bind:this={container}>
      {@render children?.()}
    </div>
  </Checkbox>
</div>
